// Force landing starts at top - fix auto-scroll to #details on Shopify
if (history.scrollRestoration) history.scrollRestoration = 'manual';
if (location.hash) history.replaceState(null, '', location.pathname + location.search);
window.addEventListener('DOMContentLoaded', () => window.scrollTo(0, 0));
window.addEventListener('load', () => setTimeout(() => window.scrollTo({top: 0, left: 0, behavior: 'instant'}), 10));

const features = [
  ["01", "Quartz chronograph", "Menampilkan fungsi jam, menit, detik, tanggal, chronograph 1/10 detik, penghitung detik, dan penghitung 30 menit."],
  ["02", "43 mm Steel Case", "Case stainless steel berukuran 43 mm dengan kombinasi permukaan fine-brushed dan polished."],
  ["03", "12.4 mm Profile", "Profil case terasa kokoh sekaligus nyaman digunakan sebagai jam tangan harian."],
  ["04", "200 Metres", "Ketahanan air hingga 200 meter memberikan perlindungan untuk penggunaan aktif sehari-hari."],
  ["05", "Sapphire Crystal", "Kaca sapphire membantu melindungi dial dari goresan dan menjaga tampilannya tetap jernih."],
  ["06", "Fixed Racing Bezel", "Fixed bezel memperkuat karakter sporty khas TAG Heuer Formula 1."],
  ["07", "Steel Bracelet", "Bracelet stainless steel dengan finishing fine-brushed serta folding clasp dan push-buttons."],
  ["08", "Special Edition Details", "Dial, kombinasi warna, dan caseback khusus membedakan edisi Red Bull Racing dari Formula 1 reguler."]
];

const featureGrid = document.getElementById("feature-grid");
if (featureGrid) {
  featureGrid.innerHTML = features.map(([number, title, description]) => `
    <article data-reveal><span>${number}</span><div class="gauge"><i></i></div><h3>${title}</h3><p>${description}</p></article>
  `).join("");
}

const menuButton = document.getElementById("menu-button");
const nav = document.getElementById("main-nav");
if (menuButton && nav) {
  menuButton.addEventListener("click", () => {
    const open = nav.classList.toggle("open");
    menuButton.textContent = open ? "×" : "☰";
    menuButton.setAttribute("aria-expanded", String(open));
  });
  nav.querySelectorAll("a").forEach(link => link.addEventListener("click", () => { nav.classList.remove("open"); menuButton.textContent = "☰"; }));
}

const galleryThumbs = document.getElementById("gallery-thumbs");
if (galleryThumbs) {
  const galleryMain = document.getElementById("gallery-main");
  galleryThumbs.querySelectorAll("button").forEach(button => button.addEventListener("click", () => {
    galleryThumbs.querySelectorAll("button").forEach(item => item.classList.remove("active"));
    button.classList.add("active");
    galleryMain.src = button.dataset.image;
  }));
}

const observer = new IntersectionObserver(entries => entries.forEach(entry => {
  if (entry.isIntersecting) entry.target.classList.add("is-visible");
}), { threshold: 0.14 });
document.querySelectorAll("[data-reveal]").forEach(element => observer.observe(element));

const stickyBar = document.getElementById("sticky-bar");
if (stickyBar) {
  const hero = document.getElementById("top");
  if (hero) {
    const stickyObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          stickyBar.style.display = "flex";
          stickyBar.classList.add("is-visible");
        } else {
          stickyBar.style.display = "none";
          stickyBar.classList.remove("is-visible");
        }
      });
    }, { threshold: 0 });
    stickyObserver.observe(hero);
  }
}

// ponytail: page-scoped lead state; cross-device deduplication belongs to the API.
(function () {
  const dialog = document.getElementById('pgj-consultation');
  if (!dialog) return;
  const form = dialog.querySelector('form');
  const fields = form.elements;
  const status = dialog.querySelector('[data-lead-status]');
  const next = dialog.querySelector('[data-lead-continue]');
  const resetBtn = dialog.querySelector('[data-lead-reset]');
  const submit = form.querySelector('[type=submit]');
  const config = dialog.dataset;
  const endpoint = config.endpoint;
  // UTM-based WA routing: halaman sama, nomor beda.
  // External (default) = data-whatsapp, mis. 6285880170977.
  // Internal = data-whatsapp-internal, mis. 6282298616979, aktif saat
  // utm_campaign / utm_source / utm_content mengandung trigger (default: "internal").
  // Contoh internal: ?utm_campaign=tag-heuer-f1-rbr-internal
  function pickWhatsapp() {
    try {
      const params = new URLSearchParams(location.search || '');
      const triggers = String(config.whatsappTrigger || 'internal').split(',').map(s => s.trim().toLowerCase()).filter(Boolean);
      if (!triggers.length) return config.whatsapp;
      const haystack = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].map(k => (params.get(k) || '').toLowerCase());
      const isInternal = haystack.some(value => triggers.some(trigger => value.includes(trigger)));
      if (isInternal && /^[1-9]\d{7,14}$/.test(config.whatsappInternal || '')) return config.whatsappInternal;
    } catch (_) { /* URL parsing must not block consultation. */ }
    return config.whatsapp;
  }
  config.whatsapp = pickWhatsapp();
  // Apps Script /exec diizinkan sebagai penyimpanan sementara; naik ke app proxy /apps/ + CAPI saat production.
  let crossOrigin = false;
  const endpointValid = (() => {
    if (/^\/apps\/[a-zA-Z0-9/_-]+$/.test(endpoint)) return true;
    try {
      const url = new URL(endpoint);
      crossOrigin = true;
      return url.protocol === 'https:' && url.hostname === 'script.google.com' && url.pathname.endsWith('/exec');
    } catch (_) { return false; }
  })();
  const ready = endpointValid && /^[1-9]\d{7,14}$/.test(config.whatsapp) && !!config.variantId;
  let requestId;
  let saved;
  let contactSent = false;
  let opener;
  let viewSent = false;
  const marketingAllowed = () => window.Shopify?.customerPrivacy?.marketingAllowed?.() === true;
  const eventData = () => ({
    product_id: config.productId, variant_id: config.variantId, sku: config.sku,
    content_ids: [config.variantId], content_type: 'product',
    content_name: config.productTitle, value: Number(config.value), currency: config.currency
  });
  function publish(name, extra = {}) {
    // Store events always emitted (payload is PII-free). Consent gating for actual
    // Meta delivery belongs to the Custom Pixel subscriber (browser) and CAPI
    // (server), both of which receive the consent flag. Gating here caused
    // ViewContent/Lead to silently never fire before consent was granted.
    try {
      const pending = window.Shopify?.analytics?.publish?.(name, { ...eventData(), ...extra });
      pending?.catch?.(() => {});
    } catch (_) { /* Tracking failure must not block consultation. */ }
  }
  function directFbq(name, params, eventID) {
    // Direct browser event on the already-loaded Meta pixel (no init, no hardcoded ID).
    // Guarantees the event is readable in Events Manager even if the subscriber
    // mapping is wrong. eventID is shared with the store event + CAPI so all
    // channels deduplicate instead of doubling.
    try {
      if (typeof fbq === 'function') fbq('track', name, params, { eventID });
    } catch (_) { /* Pixel failure must not block consultation. */ }
  }
  function dataLayerPush(name, params, eventId) {
    // GTM path: halaman landing tidak memuat fbq langsung, jadi selain store event
    // (subscriber) dan direct fbq, theme juga mendorong dataLayer agar tag GTM bisa
    // memakai Custom Event trigger pgj_* tanpa menebak DOM. Payload tanpa PII.
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...params, event_id: eventId });
    } catch (_) { /* Tracking failure must not block consultation. */ }
  }
  let viewEventId = '';
  let viewPublished = false;
  function viewContent() {
    // ViewContent = pengunjung engage dari awal landing sampai CTA akhir
    // (section commerce), bukan sekadar PageView. Fire sekali per page load.
    if (viewSent || !config.variantId) return;
    try { viewEventId = 'pgj_view_' + crypto.randomUUID(); } catch (_) { viewEventId = 'pgj_view_' + Date.now(); }
    viewSent = true;
    const params = { ...eventData() };
    viewPublished = publishView();
    dataLayerPush('pgj_view_content', params, viewEventId);
    directFbq('ViewContent', params, viewEventId);
  }
  function publishView() {
    // Kaki subscriber: coba kirim store event bila API sudah siap.
    if (!viewSent || viewPublished || !viewEventId || !window.Shopify?.analytics?.publish) return viewPublished;
    publish('pgj:product_viewed', { event_id: viewEventId });
    return true;
  }
  function observeEngagement() {
    // Target = section commerce berisi CTA akhir. Fallback: fire langsung bila
    // section tidak ditemukan agar event tidak hilang diam-diam.
    let target = null;
    try { target = document.getElementById('actual'); } catch (_) { target = null; }
    if (!target || typeof IntersectionObserver !== 'function') { viewContent(); return; }
    try {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          try { observer.disconnect(); } catch (_) {}
          viewContent();
        }
      }, { threshold: 0.2 });
      observer.observe(target);
    } catch (_) { viewContent(); }
  }
  observeEngagement();
  // Retry kaki subscriber bila API Shopify belum siap saat engagement terjadi.
  document.addEventListener('visitorConsentCollected', publishView);
  window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => {
    if (!error) publishView();
  });
  submit.disabled = !ready;
  if (ready) status.textContent = '';
  // Explicit commerce tracking: single source per button so the subscriber maps
  // AddToCart ONLY to "Tambah ke Keranjang" and InitiateCheckout to "Beli Sekarang".
  // The native form POST emits no Shopify store event, so without this the
  // subscriber can only guess (e.g. firing AddToCart on checkout start = double).
  // Native submit is NOT intercepted; this listener only emits the store event.
  document.querySelectorAll('.pgj-purchase-actions button[type="submit"]').forEach(button => {
    button.addEventListener('click', () => {
      if (button.disabled) return;
      const isBuy = (button.classList && button.classList.contains('buy')) || button.value === '/checkout';
      let eventId = '';
      try { eventId = (isBuy ? 'pgj_checkout_' : 'pgj_cart_') + crypto.randomUUID(); } catch (_) { eventId = ''; }
      const extra = eventId ? { event_id: eventId } : {};
      publish(isBuy ? 'pgj:checkout_started' : 'pgj:add_to_cart', extra);
      dataLayerPush(isBuy ? 'pgj_begin_checkout' : 'pgj_add_to_cart', { ...eventData() }, eventId);
    });
  });
  document.querySelectorAll('.landing-root a[href="#pgj-consultation"]').forEach(link => {
    link.removeAttribute('target');
    link.setAttribute('aria-haspopup', 'dialog');
    link.setAttribute('aria-controls', dialog.id);
    if (link.closest('.sticky-actions')) link.lastChild.textContent = ' Chat Watch Advisor';
    link.addEventListener('click', event => {
      event.preventDefault();
      opener = link;
      if (saved && next.href) {
        // Lead sudah tersimpan di page load ini: langsung buka WA lagi,
        // tetap tampilkan dialog sebagai fallback bila popup diblokir.
        if (!contactSent) {
          contactSent = true;
          publish('pgj:whatsapp_clicked', { event_id: saved.event_id + '_contact', lead_id: saved.lead_id });
          dataLayerPush('pgj_contact', { ...eventData(), lead_id: saved.lead_id }, saved.event_id + '_contact');
        }
        beaconWaClick(saved.request_id);
        window.open(next.href, '_blank', 'noopener');
        dialog.showModal();
        return;
      }
      if (!saved && link.closest('#showroom')) fields.purpose.value = 'Booking showroom';
      dialog.showModal();
      publish('pgj:lead_form_opened');
    });
  });
  dialog.querySelector('[data-lead-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => opener?.focus());
  fields.phone.addEventListener('input', () => fields.phone.setCustomValidity(''));
  function attribution() {
    // UTM/referrer/fbclid = data URL first-party, dikirim tanpa menunggu consent cookie; _fbp/_fbc tetap di-gate.
    const result = { landing_url: location.href, wa_destination: String(config.whatsapp || '').slice(0, 20) };
    const params = new URLSearchParams(location.search);
    for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid']) {
      result[key] = (params.get(key) || '').slice(0, 500);
    }
    if (marketingAllowed()) {
      for (const key of ['_fbp', '_fbc']) {
        result[key] = (document.cookie.split('; ').find(cookie => cookie.startsWith(key + '='))?.slice(key.length + 1) || '').slice(0, 500);
      }
    }
    try { result.referrer = document.referrer ? new URL(document.referrer).origin : ''; } catch (_) { result.referrer = ''; }
    return result;
  }
  function beaconWaClick(requestId) {
    // Catat wa_clicked_at di sheet lewat GET beacon; gagal diam saja.
    try { fetch(endpoint + '?wa_click=' + encodeURIComponent(requestId), { credentials: 'omit' }).catch(() => {}); } catch (_) {}
  }
  next.addEventListener('click', () => {
    if (!saved) return;
    // Publish Contact sekali (dedupe Meta via event_id sama), beacon boleh tiap klik
    // agar wa_clicked_at tercatat walau user buka WA berkali-kali.
    if (!contactSent) {
      contactSent = true;
      publish('pgj:whatsapp_clicked', { event_id: saved.event_id + '_contact', lead_id: saved.lead_id });
      dataLayerPush('pgj_contact', { ...eventData(), lead_id: saved.lead_id }, saved.event_id + '_contact');
    }
    beaconWaClick(saved.request_id);
  });
  resetBtn?.addEventListener('click', () => {
    // Mulai lead baru di halaman yang sama tanpa reload.
    saved = undefined;
    requestId = undefined;
    contactSent = false;
    form.reset?.();
    form.hidden = false;
    next.hidden = true;
    next.removeAttribute('href');
    if (resetBtn) resetBtn.hidden = true;
    form.querySelector('fieldset').disabled = false;
    submit.disabled = !ready;
    status.textContent = '';
    form.querySelector('input[name=name]')?.focus?.();
  });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (!ready || saved || submit.disabled) return;
    fields.name.value = fields.name.value.trim();
    fields.city.value = fields.city.value.trim();
    for (const field of [fields.name, fields.city]) {
      field.setCustomValidity(field.value.length >= 2 ? '' : 'Isi minimal 2 karakter.');
      field.oninput = () => field.setCustomValidity('');
    }
    const raw = fields.phone.value.trim();
    let phone = raw.replace(/[\s()-]/g, '');
    if (phone.startsWith('08')) phone = '+62' + phone.slice(1);
    else if (phone.startsWith('62')) phone = '+' + phone;
    fields.phone.setCustomValidity(/^[+\d\s()-]+$/.test(raw) && /^\+[1-9]\d{7,14}$/.test(phone) ? '' : 'Masukkan nomor WhatsApp valid dengan kode negara.');
    if (!form.reportValidity()) return;
    requestId ||= crypto.randomUUID();
    const payload = {
      request_id: requestId,
      name: fields.name.value, phone, city: fields.city.value,
      purpose: fields.purpose.value, contact_time: fields.contact_time.value.trim(),
      consent: { contact: fields.consent.checked, marketing: marketingAllowed(), policy_version: 'pgj-consultation-v1' },
      product: { id: config.productId, variant_id: config.variantId, handle: config.productHandle, sku: config.sku, title: config.productTitle, value: Number(config.value), currency: config.currency },
      attribution: attribution()
    };
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    form.querySelector('fieldset').disabled = true;
    submit.disabled = true;
    form.setAttribute('aria-busy', 'true');
    status.textContent = 'Menyimpan data konsultasi…';
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        credentials: crossOrigin ? 'omit' : 'same-origin',
        redirect: crossOrigin ? 'follow' : 'error',
        // Apps Script menolak preflight: jangan kirim header custom, pakai text/plain agar jadi simple request.
        headers: crossOrigin ? { 'Content-Type': 'text/plain;charset=utf-8' } : { 'Content-Type': 'application/json', Accept: 'application/json', 'Idempotency-Key': requestId },
        body: JSON.stringify(payload), signal: controller.signal
      });
      if (!response.ok) throw new Error('save_failed');
      const result = await response.json();
      if (result.status !== 'saved' || result.request_id !== requestId ||
          !/^[A-Za-z0-9_-]{1,100}$/.test(result.lead_id || '') ||
          !/^[A-Za-z0-9_-]{1,120}$/.test(result.event_id || '')) throw new Error('invalid_receipt');
      saved = result;
      const message = `Halo PGJ Watches, saya ${payload.name} dari ${payload.city}. Saya tertarik dengan ${config.productTitle} (${config.sku}) dan ingin ${payload.purpose.toLowerCase()}. Nomor WhatsApp: ${phone}.${payload.contact_time ? ' Waktu dihubungi: ' + payload.contact_time + '.' : ''} Lead ID: ${result.lead_id}.`;
      next.href = 'https://wa.me/' + config.whatsapp + '?text=' + encodeURIComponent(message);
      publish('pgj:lead_form_submitted', { event_id: result.event_id, lead_id: result.lead_id });
      publish('pgj:whatsapp_clicked', { event_id: result.event_id + '_contact', lead_id: result.lead_id });
      dataLayerPush('pgj_lead', { ...eventData(), lead_id: result.lead_id }, result.event_id);
      dataLayerPush('pgj_contact', { ...eventData(), lead_id: result.lead_id }, result.event_id + '_contact');
      // Direct browser Lead on the already-loaded Meta pixel (no init, no hardcoded ID):
      // guarantees Lead is readable in Events Manager even if the subscriber mapping
      // is wrong. eventID reuses the server receipt so browser + CAPI deduplicate.
      directFbq('Lead', {
        content_name: config.productTitle, content_ids: [config.variantId],
        content_type: 'product', value: Number(config.value), currency: config.currency
      }, result.event_id);
      contactSent = true;
      beaconWaClick(result.request_id);
      status.textContent = 'Data tersimpan. Membuka WhatsApp…';
      form.hidden = true;
      next.hidden = false;
      if (resetBtn) resetBtn.hidden = false;
      // Redirect sinkron setelah save; link "Buka WhatsApp" tetap tampil sebagai
      // fallback bila popup diblokir + untuk buka ulang tanpa isi form lagi.
      window.open(next.href, '_blank', 'noopener');
      dialog.close();
    } catch (_) {
      status.textContent = 'Penyimpanan belum terkonfirmasi. WhatsApp tetap terkunci. Coba lagi; data form tetap tersedia.';
    } finally {
      clearTimeout(timeout);
      form.removeAttribute('aria-busy');
      form.querySelector('fieldset').disabled = !!saved;
      submit.disabled = !!saved;
    }
  });
})();
